import type { ReactNode } from "react";

import clsx from "clsx";
import { Tabs as AriaTabs, Tab, TabList } from "react-aria-components";

import styles from "./tabs.module.css";

type LinkTab = {
	isDisabled?: boolean;
	label: ReactNode;
	path: string;
};

export type SelectableTab = {
	id: string;
	isDisabled?: boolean;
	label: ReactNode;
};

type TabsProps =
	| { activeTab: string; onSelect: (id: string) => void; tabs: SelectableTab[] }
	| { activeTab?: string; tabs: LinkTab[] };

export function Tabs(props: TabsProps): ReactNode {
	const { activeTab, tabs } = props;
	const onSelect = "onSelect" in props ? props.onSelect : undefined;

	return (
		<AriaTabs
			keyboardActivation="manual"
			onSelectionChange={
				onSelect
					? (key) => {
							onSelect(String(key));
						}
					: undefined
			}
			orientation="horizontal"
			selectedKey={onSelect ? activeTab : undefined}
		>
			<TabList className={styles.tabs}>
				{tabs.map((tab) => {
					const key = "path" in tab ? tab.path : tab.id;
					return (
						<Tab
							className={clsx(
								"body-2",
								styles.tab,
								activeTab === key && styles.active,
							)}
							href={"path" in tab ? tab.path : undefined}
							id={key}
							isDisabled={tab.isDisabled}
							key={key}
						>
							{tab.label}
						</Tab>
					);
				})}
			</TabList>
		</AriaTabs>
	);
}
